<template>
  <div>
    <div class="common-qa">
      <van-field
        class="answer-input"
        v-model="data.value"
        :disabled="data.disabled"
        placeholder="请在这里填写吧"
        @input="bindInput"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindInput() {
      if (this.data.que_filed == 'camp_buy_order') {
        this.data.value = this.data.value.replace(
          /[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEA1}\u{2CEB0}-\u{2EBE0}]/gu,
          ''
        )
      }
      this.$emit('change', this.data.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.common-qa {
  margin-top: 25vh;
}

.answer-input {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid #f1f1f1;
}
.text {
  text-align: center;
  margin-top: 30px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
.my-swipe {
  margin-top: 20px;

  .swiper-image-item {
    width: 100%;
  }
}
</style>
